// extracted by mini-css-extract-plugin
export var button = "_4s-0";
export var icon = "_4s-1";